import { ReactNode } from 'react';
import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { authSelector } from 'redux-store/selector';

type Props = {
  children: ReactNode;
};

export const AuthCompanyGuard = ({ children }: Props) => {
  const { isAuth, companyId } = useAppSelector(authSelector);

  if (!isAuth || !companyId) return null;

  return <>{children}</>;
};
